import { ErrorHandler, Injectable, inject } from '@angular/core';
import { SentryService } from './core/services/sentry.service';
import { ApplicationService } from './core/services/application.service';

export const initApp = (appService: ApplicationService) => () =>
    appService
      .initialize()
      .toPromise()
      .catch(() => {
        console.error('Application failed to initialize');
      });

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  private sentryService = inject(SentryService);

  handleError(err) {
    const error = err.originalError || err;
    this.sentryService.logException(error);
  }
}


